// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".xOgfqz5tSHiTeqdwm0ze{display:flex;flex-direction:column;gap:.5rem}.LUvMElyDXMoxLUT5bPOE{margin-top:.5rem}", "",{"version":3,"sources":["webpack://./src/templates/imageUploadWarning/image-upload-warning.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,SAAA,CAGF,sBACE,gBAAA","sourcesContent":[".modalContent {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.modalDetails {\n  margin-top: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContent": "xOgfqz5tSHiTeqdwm0ze",
	"modalDetails": "LUvMElyDXMoxLUT5bPOE"
};
export default ___CSS_LOADER_EXPORT___;
